import React from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Activity, TrendingDown, TrendingUp } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/Tabs';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import { ChartContainer, ChartTooltipContent } from '../components/Chart';
const weekly = [{
  day: 'Sen',
  pos: 45,
  neu: 35,
  neg: 20
}, {
  day: 'Sel',
  pos: 42,
  neu: 38,
  neg: 20
}, {
  day: 'Rab',
  pos: 40,
  neu: 35,
  neg: 25
}, {
  day: 'Kam',
  pos: 38,
  neu: 32,
  neg: 30
}, {
  day: 'Jum',
  pos: 35,
  neu: 30,
  neg: 35
}, {
  day: 'Sab',
  pos: 32,
  neu: 28,
  neg: 40
}, {
  day: 'Min',
  pos: 30,
  neu: 28,
  neg: 42
}];
const platforms = [{
  name: 'X/Twitter',
  value: 35,
  color: '#3b82f6'
}, {
  name: 'TikTok',
  value: 28,
  color: '#ef4444'
}, {
  name: 'Facebook',
  value: 15,
  color: '#10b981'
}, {
  name: 'Instagram',
  value: 12,
  color: '#f59e0b'
}, {
  name: 'YouTube',
  value: 6,
  color: '#a855f7'
}, {
  name: 'Lainnya',
  value: 4,
  color: '#6b7280'
}];
const topPos = [{
  text: 'MBG mulai distribusi di Jakarta Timur, anak-anak terlihat antusias',
  src: '@info_jakartabaik',
  engage: '12.4K'
}, {
  text: 'Pertama kali lihat realisasi program hilirisasi di Sulawesi, pekerja lokal banyak',
  src: '@nikkel_watch',
  engage: '8.2K'
}, {
  text: 'Bantuan untuk korban banjir Demak datang cepat, mantap',
  src: '@warga_demak',
  engage: '5.6K'
}];
const topNeg = [{
  text: 'Harga beras gak masuk akal lagi, mana janji stabilisasi pemerintah?',
  src: '@bunda_dapur',
  engage: '45.2K'
}, {
  text: 'Bansos di kampung saya gak merata, banyak yang gak dapet',
  src: '@suara_kampung',
  engage: '28.1K'
}, {
  text: 'Pajak hiburan 75% itu bunuh industri, gimana pekerjanya?',
  src: '@bali_kreatif',
  engage: '22.8K'
}];
const config = {
  pos: {
    label: 'Positif',
    color: 'hsl(var(--chart-2))'
  },
  neu: {
    label: 'Netral',
    color: 'hsl(var(--muted-foreground))'
  },
  neg: {
    label: 'Negatif',
    color: 'hsl(var(--destructive))'
  }
};
export function Sentiment() {
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-3156">
      <PageHeader group="Radar Isu" title="Sentiment Monitoring" description="Tren sentimen publik lintas platform, 7 hari terakhir, dengan analisis post berdampak tinggi." icon={Activity} data-id="element-3157" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3158">
        {[{
        label: 'Sentimen Positif',
        value: '30%',
        delta: '-5%',
        color: 'text-emerald-500'
      }, {
        label: 'Sentimen Netral',
        value: '28%',
        delta: '-2%',
        color: 'text-muted-foreground'
      }, {
        label: 'Sentimen Negatif',
        value: '42%',
        delta: '+7%',
        color: 'text-red-500'
      }, {
        label: 'Total Mentions',
        value: '4.2M',
        delta: '+12%',
        color: 'text-blue-500'
      }].map(k => <Card key={k.label} className="bg-card border-border/50" data-id="element-3159">
            <CardContent className="p-4" data-id="element-3160">
              <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-3161">
                {k.label}
              </p>
              <div className="flex items-baseline gap-2 mt-1" data-id="element-3162">
                <p className={`font-heading text-2xl font-bold ${k.color}`} data-id="element-3163">
                  {k.value}
                </p>
                <span className={`text-xs ${k.delta.startsWith('+') ? 'text-red-500' : 'text-emerald-500'}`} data-id="element-3164">
                  {k.delta}
                </span>
              </div>
            </CardContent>
          </Card>)}
      </div>

      <div className="grid grid-cols-12 gap-4" data-id="element-3165">
        {/* Main Chart */}
        <Card className="col-span-12 lg:col-span-8 bg-card border-border/50" data-id="element-3166">
          <CardHeader className="border-b border-border/50 py-3" data-id="element-3167">
            <CardTitle className="font-mono text-xs uppercase tracking-wider text-muted-foreground" data-id="element-3168">
              Tren Sentimen 7 Hari
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 h-[350px]" data-id="element-3169">
            <ChartContainer config={config} className="h-full w-full" data-id="element-3170">
              <LineChart data={weekly} margin={{
              top: 10,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-3171">
                <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} data-id="element-3172" />
                <XAxis dataKey="day" stroke="hsl(var(--muted-foreground))" fontSize={10} tickLine={false} axisLine={false} data-id="element-3173" />
                <YAxis stroke="hsl(var(--muted-foreground))" fontSize={10} tickLine={false} axisLine={false} data-id="element-3174" />
                <Tooltip content={<ChartTooltipContent data-id="element-3176" />} data-id="element-3175" />
                <Line type="monotone" dataKey="pos" stroke="var(--color-pos)" strokeWidth={2} dot={{
                r: 3
              }} data-id="element-3177" />
                <Line type="monotone" dataKey="neu" stroke="var(--color-neu)" strokeWidth={2} dot={{
                r: 3
              }} data-id="element-3178" />
                <Line type="monotone" dataKey="neg" stroke="var(--color-neg)" strokeWidth={2} dot={{
                r: 3
              }} data-id="element-3179" />
              </LineChart>
            </ChartContainer>
          </CardContent>
        </Card>

        {/* Emotion Breakdown */}
        <Card className="col-span-12 lg:col-span-4 bg-card border-border/50" data-id="element-3180">
          <CardHeader className="border-b border-border/50 py-3" data-id="element-3181">
            <CardTitle className="font-mono text-xs uppercase tracking-wider text-muted-foreground" data-id="element-3182">
              Distribusi Platform
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 h-[350px]" data-id="element-3183">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3184">
              <PieChart data-id="element-3185">
                <Pie data={platforms} cx="50%" cy="50%" innerRadius={50} outerRadius={80} paddingAngle={2} dataKey="value" data-id="element-3186">
                  {platforms.map(p => <Cell key={p.name} fill={p.color} data-id="element-3187" />)}
                </Pie>
                <Tooltip data-id="element-3188" />
                <Legend wrapperStyle={{
                fontSize: 10,
                fontFamily: 'monospace'
              }} data-id="element-3189" />
              </PieChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </div>

      {/* Top Keywords */}
      <Card className="bg-card border-border/50" data-id="element-3190">
        <CardContent className="p-4" data-id="element-3191">
          <Tabs defaultValue="pos" data-id="element-3192">
            <div className="border-b border-border/50 px-4" data-id="element-3193">
              <TabsList className="bg-transparent" data-id="element-3194">
                <TabsTrigger value="pos" className="font-mono text-[10px] uppercase data-[state=active]:bg-muted/50" data-id="element-3195">
                  <TrendingUp className="size-3 mr-1 text-emerald-500" data-id="element-3196" /> Top
                  Positif
                </TabsTrigger>
                <TabsTrigger value="neg" className="font-mono text-[10px] uppercase data-[state=active]:bg-muted/50" data-id="element-3197">
                  <TrendingDown className="size-3 mr-1 text-red-500" data-id="element-3198" /> Top
                  Negatif
                </TabsTrigger>
              </TabsList>
            </div>
            <TabsContent value="pos" className="p-4 space-y-2 m-0" data-id="element-3199">
              {topPos.map(p => <div key={p.text} className="p-3 rounded border border-emerald-500/20 bg-emerald-500/5 flex items-center justify-between gap-4" data-id="element-3200">
                  <div data-id="element-3201">
                    <p className="text-sm" data-id="element-3202">{p.text}</p>
                    <p className="font-mono text-[10px] text-muted-foreground mt-1" data-id="element-3203">
                      {p.src}
                    </p>
                  </div>
                  <span className="font-mono text-xs text-emerald-500 shrink-0" data-id="element-3204">
                    {p.engage}
                  </span>
                </div>)}
            </TabsContent>
            <TabsContent value="neg" className="p-4 space-y-2 m-0" data-id="element-3205">
              {topNeg.map(p => <div key={p.text} className="p-3 rounded border border-red-500/20 bg-red-500/5 flex items-center justify-between gap-4" data-id="element-3206">
                  <div data-id="element-3207">
                    <p className="text-sm" data-id="element-3208">{p.text}</p>
                    <p className="font-mono text-[10px] text-muted-foreground mt-1" data-id="element-3209">
                      {p.src}
                    </p>
                  </div>
                  <span className="font-mono text-xs text-red-500 shrink-0" data-id="element-3210">
                    {p.engage}
                  </span>
                </div>)}
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>;
}